<!-- <router-outlet></router-outlet> -->
<div id="all" *ngIf="datas && (!isVP)" (click)="onClick()" [class]="'fullHD roboto step-'+current" [class.smallerScreen]="smallerScreen">
  <div *ngIf="!isVP && (current=='video' || current=='question') && currentVideo" id="video" class="fullHD" (click)="onVideoClick()">
    <video #video autoplay [src]="base+datasName+'/videos/'+currentVideo" class="fullHD" (ended)="onVideoEnded($event)" (timeupdate)="onTimeupdate($event)" [attr.loop]="loop ? 'loop' : null"></video>
    <!-- <video #video autoplay [src]="base+datasName+'/files/'+datas.video" class="fullHD" [poster]="base+'files/'+getPoster(datas.video)" (ended)="onVideoEnded($event)"></video> -->
    <!-- <div class="progressBar"><div class="progressingBar" [style.backgroundColor]="datas.color" [style.width]="videoProgress+'%'"></div></div> -->
  </div>
  <div id="splash" class="page roboto fullHD" *ngIf="current == 'splash'" (click)="onSplashClick()" [style.background]="bgImage">
    <div class="group">
      <div class="title suburban"><span [innerHTML]="datas.title" [style.backgroundColor]="espace.color">...</span></div>
      <div class="baseline">
        <span [innerHTML]="datas.baseline">...</span>
        <span class="picto" *ngIf="espace" [style.backgroundColor]="espace.color">
          <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-play-fill" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path d="M11.596 8.697l-6.363 3.692c-.54.313-1.233-.066-1.233-.697V4.308c0-.63.692-1.01 1.233-.696l6.363 3.692a.802.802 0 0 1 0 1.393z"/>
          </svg>
        </span>
      </div>
    </div>
  </div>
  <div id="game" *ngIf="current == 'game'" class="fullHD">
    <iframe #iframe [src]="iframeUrl" class="fullHD"></iframe>
    <div class="controls">
      <div class="property" *ngFor="let property of properties; let i = index;">
        <a class="btn left" (click)="remove(i)" [style.backgroundColor]="espace.color">-</a>
        <div class="title" [style.backgroundColor]="espace.color">
          <span>{{property.title}} : {{property.value}}%</span>
          <a class="help" *ngIf="showHelp != property" [style.backgroundColor]="espace.color" (click)="openHelp(property)">?</a>
          <a class="close" *ngIf="showHelp == property" [style.backgroundColor]="espace.color" (click)="closeHelp(property)">&times;</a>
        </div>
        <a class="btn right" (click)="add(i)" [style.backgroundColor]="espace.color">+</a>
        <div class="spacer"></div>
        <div class="description" [style.backgroundColor]="espace.color" [class.opened]="showHelp == property">
          <div class="inner" [innerHTML]="property.description"></div>
        </div>
      </div>
      <!-- <div class="help" *ngIf="!showHelp" [style.backgroundColor]="espace.color" (click)="openHelp()">?</div>
      <div class="close" *ngIf="showHelp" [style.backgroundColor]="espace.color" (click)="closeHelp()">&times;</div> -->
    </div>
  </div>

  <!-- ************************************ -->
  <div class="instruction fullHD absolute" *ngIf="current == 'introduction'" (click)="onInstructionClick()"  [style.background]="bgImage">
    <div class="bloc absolute">
      <div class="inner">
        <h1 [innerHTML]="datas.introduction_title" class="suburban"></h1>
        <div class="details table">
          <div class="cell" [innerHTML]="datas.introduction_description"></div>
          <div class="center">
            <a (click)="onInstructionClick()" class="next suburban">
                <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" class="bi bi-caret-right-fill" viewBox="0 0 16 16">
    <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z"/>
  </svg>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="conclusion fullHD absolute" *ngIf="current == 'conclusion'">
    <div class="bloc absolute">
      <div class="inner">
        <div class="table">
          <div class="cell">
            <h1 [innerHTML]="datas.conclusion_title"></h1>
            <div [innerHTML]="datas.conclusion_description"></div>
            <div class="center">
              <a (click)="onRestart()" class="next suburban">
                <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" class="bi bi-arrow-counterclockwise" viewBox="0 0 16 16">
                  <path fill-rule="evenodd" d="M8 3a5 5 0 1 1-4.546 2.914.5.5 0 0 0-.908-.417A6 6 0 1 0 8 2v1z"/>
                  <path d="M8 4.466V.534a.25.25 0 0 0-.41-.192L5.23 2.308a.25.25 0 0 0 0 .384l2.36 1.966A.25.25 0 0 0 8 4.466z"/>
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <a class="homeBtn" (click)="goHome()">
    <svg version="1.1" id="Calque_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 16 16" style="enable-background:new 0 0 16 16;" xml:space="preserve" fill="currentColor">
      <path class="st0" d="M14,15c0.28,0,0.5-0.22,0.5-0.5v-7c0-0.13-0.05-0.26-0.15-0.35l-6-6c-0.2-0.2-0.51-0.2-0.71,0l0,0l-6,6
      C1.55,7.24,1.5,7.37,1.5,7.5v7C1.5,14.78,1.72,15,2,15H14z"/>
    </svg>
  </a>
  <!-- ************************************ -->

</div>
<div id="debug" [innerHTML]="debugTxt" *ngIf="debug"></div>
